<!-- =========================================================================================
    File Name: ChatLog.vue
    Description: Chat Application - Log of chat
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<!-- hasSentPreviousMsg -->
<template>
  <div id="component-chat-log" class="m-8 pb-32">
    <a href="/dashboard/analytics">
      <FeatherIcon v-if="false" icon="HomeIcon" style="width: 30px; vertica-align: bottom"></FeatherIcon>
      <span v-if="false" style="vertical-align: super; font-weight: 900">Back Home</span>
    </a>


    <div v-if="chatData && chatData.Chat && chatData.Chat.length > 0">
      <div v-for="(msg, index) in chatData.Chat" class="msg-grp-container" :key="index">
        <!-- If previouse msg is older than current time -->
        <template v-if="msg && !msg.HideFromUI">
          <vs-divider v-if="index > 0 && !isSameDay(msg.time, chatData.Chat[index - 1].time)">
            <span>{{ toDate(msg.time) }}</span>
          </vs-divider>
          <div class="spacer mt-8" v-if="index > 0 && !hasSentPreviousMsg(chatData.Chat[index - 1].isSent, msg.isSent)"></div>
        </template>

        <div class="flex items-start" :class="[{ 'flex-row-reverse': msg.isSent }]">
          <vs-avatar v-if="!msg.HideFromUI" size="40px" class="m-0 flex-shrink-0"
                     :class="msg.isSent ? 'sm:ml-5 ml-3' : 'sm:mr-5 mr-3'" :src="senderImg(msg.isSent)"></vs-avatar>

          <div v-if="!msg.HideFromUI" class="msg break-words relative shadow-md rounded py-3 px-4 mb-2 rounded-lg"
               :class="{
            'bg-primary-gradient text-white max-w-sm': msg.isSent,
            'border border-solid border-grey-light bg-white': !msg.isSent,
          }">
            <div v-if="!msg.HideFromUI && getComponentsFromHtml(msg.content) == null" class="chat-cart-html"
                 v-html="msg.content"></div>
            <div v-else>
              <component v-if="!msg.HideFromUI && !msg.SkipCards" :is="getComponentsFromHtml(msg.content)"
                         :RawSettings="msg.content" @RaiseCta="RaiseCta"></component>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Typing Indicator -->
    <template v-if="isTyping">
      <div class="flex items-start mb-4">
        <vs-avatar size="40px" class="m-0 flex-shrink-0" :class="'sm:mr-5 mr-3'" :src="senderImg(false)"
                   style="background: white"></vs-avatar>
        <div class="msg break-words relative shadow-md rounded py-3 px-4 mb-2 rounded-lg border border-solid border-grey-light bg-white">
          {{ GetAIState() }}
        </div>
      </div>
    </template>

    <!-- Chat Input Box - Fixed at bottom -->
    <div class="chat-input-container fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 p-4 shadow-lg">
      <div class="flex items-center space-x-3 max-w-4xl mx-auto">
        <input v-model="newMessage"
               @keyup.enter="sendMessage"
               type="text"
               placeholder="Type your message here..."
               class="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent" />
        <vs-button @click="sendMessage"
                   class="px-6 py-2 rounded-lg ml-3 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2">
          Send
        </vs-button>
      </div>
    </div>

    <!-- Spacer to prevent content from being hidden behind fixed input -->
    <div class="h-24"></div>
  </div>
</template>

<script>
  import TCVCard from "@/views/components/chat/TCVCard.vue";
  import FeatherIcon from "@/components/FeatherIcon.vue";
  import VxCard from "@/components/vx-card/VxCard.vue";
  import TCVelikClient from "@/TCVelikClient/TCVelikClient.js";
  import accountsService from "@/accounts/accountsService.js";

  export default {
    props: {
      OtherIsTyping: {
        type: Boolean,
        required: false,
      },
      tools: {
        type: Array,
        required: false,
        default: () => [
          {
            type: "function",
            function: {
              name: "get_graphql_schema",
              description: "Get the GraphQL schema from the /graphql endpoint"
            }
          },
          {
            type: "function",
            function: {
              name: "get_available_intents",
              description: "Use this every time a user asks a question. Returns all custom fields and values that can be used to determine user intent when asking questions."
            }
          },
          {
            type: "function",
            function: {
              name: "search_with_intent",
              description: "Performs a search with intent parameters. Use this to search for content with specific filters. Parameters: query (string), urlContext (string, optional), shortResults (boolean, default true), format (string, optional), maxCount (number, default 50), intentParams (object with intent categories and values). The intents can be taken from the get_available_intents function."
            }
          },
          {
            type: "function",
            function: {
              name: "display_search_results",
              description: "Displays the given search results"
            }
          },
          {
            type: "function",
            function: {
              name: "get_current_user",
              description: "Gets the current authenticated user information including roles, account details, and preferences"
            }
          }
        ]
      },
    },
    data() {
      return {
        customComponent: "",
        newMessage: "",
        isTyping: false,
        functionCallCount: 0, // Track consecutive function calls
        maxFunctionCalls: 10, // Maximum allowed function calls
        chat: {
          Chat: [
            {
              content: "USE RAW HTML (P, DIV, LI, UL, TABLES). DO NOT USE MARKDOWN. You are the assistant that can help users perform their tasks by assisting them finding SOPs for either all clients or specific clients. Output your contnet in raw HTML. Follow the language of the user. Be nice and concise. DO NOT OUTPUT Markdown. In most cases you want to get available intents first to make the search better. To link to SOP, use the following url: /pages/pdf-view?oid=(SOP ID) - where SOP id is the id of the item (not the unique ID, but the ID). AGAIN NO MARKDOWN, JUST PLAIN TEXT OR HTML. FOR SOP LINKS USE A href... USE RAW HTML (P, DIV, LI, UL, TABLES).  DO NOT USE MARKDOWN. Be somewhat playful and positive. Use emojis but not a lot.",
              isSent: false,
              time: new Date().toISOString(),
              HideFromUI: true,
              Role: "System",
              SkipCards: false,
            },
            {
              content: "Hey!<br/> I am your assistant.<br/>Let me know what do you need and I'll do my best to help?",
              isSent: false,
              time: new Date().toISOString(),
              HideFromUI: false,
              SkipCards: false,
            }
          ]
        },
        contactsArr: [
          {
            id: 1,
            name: "User",
            about: "AI Chat User",
            img: require("@/assets/images/logo/logo.jpg"),
            status: "online",
          },
          {
            id: 2,
            name: "TCVelik Assistant",
            about: "AI Assistant",
            img: require("@/assets/images/logo/logo.jpg"),
            status: "online",
          },
        ],
      };
    },
    computed: {
      chatData() {
        return this.chat;
      },
      contactIndex() {
        return this.contactsArr.findIndex((contact) => contact.id == 1); // Default to first contact for now
      },
      userImg() {
        var user = accountsService.getUserObjectFromLocalStorageSafe();
        
        if (this.contactIndex !== -1)
          return this.contactsArr[this.contactIndex].img;
      },
      activeUserImg() {
        return this.userImg || require("@/assets/images/logo/logo.jpg");
      },
      senderImg(isSentByActiveUser) {
        return (isSentByActiveUser) => {
          if (isSentByActiveUser) return this.userImg || require("@/assets/images/logo/logo.jpg");
          else {
            return require("@/assets/images/logo/logo.jpg");
          }
        };
      },
      hasSentPreviousMsg() {
        return (last_sender, current_sender) => last_sender == current_sender;
      },
    },
    methods: {
      isSameDay(time_to, time_from) {
        const date_time_to = new Date(Date.parse(time_to));
        const date_time_from = new Date(Date.parse(time_from));
        return (
          date_time_to.getFullYear() === date_time_from.getFullYear() &&
          date_time_to.getMonth() === date_time_from.getMonth() &&
          date_time_to.getDate() === date_time_from.getDate()
        );
      },
      GetAIState() {
        return "AI is thinking...";
      },
      toDate(time) {
        const locale = "en-us";
        const date_obj = new Date(Date.parse(time));
        const monthName = date_obj.toLocaleString(locale, {
          month: "short",
        });
        return date_obj.getDate() + " " + monthName;
      },
      scrollToBottom() {
        this.$nextTick(() => {
          const chatContainer = document.getElementById('component-chat-log');
          if (chatContainer) {
            chatContainer.scrollTop = chatContainer.scrollHeight;
          }
        });
      },
      getComponentsFromHtml(html) {
        return null;
      },
      RaiseCta(cta, data) {
        this.$emit("RaiseCta", cta, data);
      },
      RecordFeedbackUpdate(objParams) {
        alert(objParams.ItemHtml);
      },

      // Function calling methods
      async handleFunctionCall(functionName, functionArgs) {
        console.log('Handling function call:', functionName, functionArgs);

        switch (functionName) {
          case 'get_graphql_schema':
            return await this.getGraphQLSchema();
          case 'get_available_intents':
            var result = await TCVelikClient.GetRelative("/api/existingintents");
            return {
              success: true,
              schema: result.data,
              message: 'Intents retrieved successfully'
            }
          case 'search_with_intent':
            try {
              const searchRequest = {
                query: functionArgs.query || "",
                urlContext: functionArgs.urlContext || "",
                shortResults: functionArgs.shortResults !== undefined ? functionArgs.shortResults : true,
                format: functionArgs.format || "",
                maxCount: functionArgs.maxCount || 50,
                intentParams: functionArgs.intentParams || functionArgs.filters || {}
              };

              console.log('Search request:', searchRequest);

              const searchResult = await TCVelikClient.PostRelative("/api/SearchWithIntent", searchRequest);
              return {
                success: true,
                results: searchResult.data,
                message: 'Search completed successfully'
              };
            } catch (error) {
              console.error('Search error:', error);
              return {
                success: false,
                error: error.message || 'Search failed'
              };
            }
          case 'get_current_user':
            try {
              // First try to get user from localStorage
              const userFromStorage = accountsService.getUserObjectFromLocalStorageSafe();

              if (userFromStorage) {
                  return {
                    success: true,
                    user: userFromStorage,
                    message: 'User information retrieved from cache successfully'
                  };
              }
            } catch (error) {
              console.error('Get current user error:', error);
              return {
                success: false,
                error: error.message || 'Failed to retrieve user information'
              };
            }
          default:
            console.warn('Unknown function:', functionName);
            return { error: `Unknown function: ${functionName}` };
        }
      },

      async getGraphQLSchema() {
        try {
          const response = await TCVelikClient.PostRelative('/api/graphql', {
            query: `
            query SimpleIntrospectionQuery {
              __schema {
                queryType {
                  name
                  fields {
                    name
                    description
                    args {
                      name
                      description
                      type {
                        name
                        kind
                      }
                    }
                    type {
                      name
                      kind
                    }
                  }
                }
              }
            }
              `
          });

          return {
            success: true,
            schema: response.data,
            message: 'GraphQL schema retrieved successfully'
          };
        } catch (error) {
          console.error('Error fetching GraphQL schema:', error);
          return {
            success: false,
            error: error.message || 'Failed to fetch GraphQL schema'
          };
        }
      },

      // Helper method to create function result summary
      createFunctionResultSummary(functionName, functionResult) {
        if (!functionResult) return "No result";

        if (functionResult.success === false) {
          return `❌ Error: ${functionResult.error || 'Unknown error'}`;
        }

        if (functionResult.success === true) {
          if (functionResult.message) {
            return `✅ ${functionResult.message}`;
          }

          // Create summary based on result type
          if (functionResult.schema) {
            return `✅ Schema retrieved (${typeof functionResult.schema === 'object' ? 'Object' : 'Data'})`;
          }

          if (functionResult.results) {
            const count = Array.isArray(functionResult.results) ? functionResult.results.length : 1;
            return `✅ Search completed - ${count} result${count !== 1 ? 's' : ''}`;
          }

          if (functionResult.user) {
            const userName = functionResult.user.User ? functionResult.user.User.UserName || functionResult.user.User.Email : 'User';
            return `✅ User information retrieved for ${userName}`;
          }

          return `✅ Function executed successfully`;
        }

        // Fallback for unknown result format
        return `✅ Function completed`;
      },

      // Helper method to extract content from different response formats
      extractContent(content) {
        if (!content) return "I'm sorry, I couldn't generate a response.";

        // If Content is a string, try to parse it as JSON first
        if (typeof content === 'string') {
          try {
            // Try to parse as JSON
            const parsedContent = JSON.parse(content);
            console.log('Parsed JSON content:', parsedContent);

            if (Array.isArray(parsedContent)) {
              // If it's an array of objects with Text property
              const textParts = parsedContent
                .filter(item => item.Text)
                .map(item => item.Text);
              return textParts.join(' ');
            } else if (parsedContent.Text) {
              // If it's an object with Text property
              return parsedContent.Text;
            } else {
              // Fallback to original string if parsing doesn't give us what we expect
              return content;
            }
          } catch (parseError) {
            // If JSON parsing fails, use the string as-is
            return content;
          }
        }
        // If Content is an array of objects with Text property
        else if (Array.isArray(content)) {
          const textParts = content
            .filter(item => item.Text)
            .map(item => item.Text);
          return textParts.join(' ');
        }
        // If Content is an object with Text property
        else if (content.Text) {
          return content.Text;
        }
        // If Content is an object, try to stringify it for debugging
        else {
          console.log('Unexpected Content format:', content);
          return "I received your message but the response format was unexpected.";
        }
      },

      async sendMessage() {
        if (this.newMessage.trim()) {
          const userMessage = this.newMessage.trim();

          // Add user message to chat
          this.chat.Chat.push({
            content: userMessage,
            isSent: true,
            time: new Date().toISOString(),
            HideFromUI: false,
            SkipCards: false
          });

          // Clear input
          this.newMessage = "";

          // Show typing indicator
          this.isTyping = true;

          // Reset function call count for new user message
          this.functionCallCount = 0;

          try {
            // Start the conversation loop
            await this.processConversationLoop();
          } catch (error) {
            console.error('Error in conversation loop:', error);

            // Add error message to chat
            this.chat.Chat.push({
              content: "I'm sorry, I encountered an error while processing your request. Please try again.",
              isSent: false,
              time: new Date().toISOString(),
              HideFromUI: false,
              SkipCards: false
            });
          } finally {
            // Hide typing indicator
            this.isTyping = false;
          }
        }
      },

      // New method to handle the conversation loop with multiple function calls
      async processConversationLoop() {
        // Prepare initial messages for OpenAI API
        let messages = this.chat.Chat.map(msg => ({
          Role: msg.isSent ? "User" : "Assistant",
          Content: msg.content
        }));

        // Add system message if this is the first conversation
        if (messages.length === 1) {
          messages.unshift({
            Role: "System",
            Content: "You are a helpful AI assistant. Provide clear, concise, and helpful responses."
          });
        }

        let conversationComplete = false;

        // Create a single thinking card for all function calls
        let thinkingCardId = null;
        let thinkingCardContent = {
          title: "🤔 Thinking...",
          subtitle: "Processing your request",
          functionCalls: [],
          isComplete: false
        };

        // Add the initial thinking card
        this.chat.Chat.push({
          content: this.createThinkingCardContent(thinkingCardContent),
          isSent: false,
          time: new Date().toISOString(),
          HideFromUI: false,
          SkipCards: false,
          isThinkingCard: true // Mark this as a thinking card
        });

        // Get the index of the thinking card for updates
        thinkingCardId = this.chat.Chat.length - 1;

        while (!conversationComplete && this.functionCallCount < this.maxFunctionCalls) {
          try {
            // Call OpenAI API with tools
            const requestBody = {
              Messages: messages,
              Tools: this.tools
            };

            console.log(`API call ${this.functionCallCount + 1}/${this.maxFunctionCalls}:`, requestBody);

            const response = await TCVelikClient.PostRelative('/api/OpenAI/ChatWithFunctions', requestBody);

            console.log('Full API response:', response);
            console.log('Response data:', response.data);

            // Check if this is a function call response
            if (response.data && response.data.Messages && response.data.Messages.length > 0) {
              const lastMessage = response.data.Messages[response.data.Messages.length - 1];
              console.log('Last message:', lastMessage);

              // Check for function call
              if (lastMessage.ToolCalls && lastMessage.ToolCalls.length > 0) {
                console.log('Function call detected:', lastMessage.ToolCalls);

                // Increment function call count
                this.functionCallCount++;

                // Check if we've exceeded the limit
                if (this.functionCallCount >= this.maxFunctionCalls) {
                  // Update thinking card with limit exceeded
                  thinkingCardContent.title = "⚠️ Function Call Limit Reached";
                  thinkingCardContent.subtitle = `Maximum of ${this.maxFunctionCalls} tool calls exceeded`;
                  thinkingCardContent.isComplete = true;
                  this.updateThinkingCard(thinkingCardId, thinkingCardContent);

                  conversationComplete = true;
                  break;
                }

                // Handle the first tool call (you can extend this to handle multiple)
                const toolCall = lastMessage.ToolCalls[0];

                // Add function call to thinking card
                thinkingCardContent.functionCalls.push({
                  name: toolCall.FunctionName,
                  status: 'calling',
                  timestamp: new Date().toLocaleTimeString()
                });

                // Update thinking card
                this.updateThinkingCard(thinkingCardId, thinkingCardContent);

                // Execute the function
                try {
                  const functionResult = await this.handleFunctionCall(
                    toolCall.FunctionName,
                    toolCall.FunctionArguments ? JSON.parse(toolCall.FunctionArguments) : {}
                  );

                  console.log('Function result:', functionResult);

                  // Update function call status to completed
                  const functionCallIndex = thinkingCardContent.functionCalls.findIndex(fc => fc.name === toolCall.FunctionName);
                  if (functionCallIndex !== -1) {
                    thinkingCardContent.functionCalls[functionCallIndex].status = 'completed';
                    thinkingCardContent.functionCalls[functionCallIndex].result = functionResult;
                  }

                  // Update thinking card
                  this.updateThinkingCard(thinkingCardId, thinkingCardContent);

                  // Add the function result to messages for the next iteration
                  messages.push({
                    Role: "Assistant",
                    Content: `I called the function ${toolCall.FunctionName} and got the result: ${JSON.stringify(functionResult)}`
                  });

                  // Continue the loop for potential additional function calls
                  continue;

                } catch (functionError) {
                  console.error('Function execution error:', functionError);

                  // Update function call status to error
                  const functionCallIndex = thinkingCardContent.functionCalls.findIndex(fc => fc.name === toolCall.FunctionName);
                  if (functionCallIndex !== -1) {
                    thinkingCardContent.functionCalls[functionCallIndex].status = 'error';
                    thinkingCardContent.functionCalls[functionCallIndex].error = functionError.message;
                  }

                  // Update thinking card
                  this.updateThinkingCard(thinkingCardId, thinkingCardContent);

                  // Add error to messages and continue
                  messages.push({
                    Role: "Assistant",
                    Content: `I encountered an error while calling the function ${toolCall.FunctionName}: ${functionError.message}`
                  });
                  continue;
                }
              } else {
                // Regular message response - no more function calls needed
                const content = this.extractContent(lastMessage.Content);

                // Update thinking card to show completion
                thinkingCardContent.title = "✅ Complete";
                thinkingCardContent.subtitle = "Request processed successfully";
                thinkingCardContent.isComplete = true;
                this.updateThinkingCard(thinkingCardId, thinkingCardContent);

                // Add final response to chat
                this.chat.Chat.push({
                  content: content,
                  isSent: false,
                  time: new Date().toISOString(),
                  HideFromUI: false,
                  SkipCards: false
                });

                conversationComplete = true;
              }
            } else if (response.data && Array.isArray(response.data)) {
              // Direct array response: response.data is the array
              console.log('Direct array response:', response.data);
              const textParts = response.data
                .filter(item => item.Text)
                .map(item => item.Text);
              const content = textParts.join(' ');
              console.log('Using direct array content:', content);

              // Update thinking card to show completion
              thinkingCardContent.title = "✅ Complete";
              thinkingCardContent.subtitle = "Request processed successfully";
              thinkingCardContent.isComplete = true;
              this.updateThinkingCard(thinkingCardId, thinkingCardContent);

              this.chat.Chat.push({
                content: content,
                isSent: false,
                time: new Date().toISOString(),
                HideFromUI: false,
                SkipCards: false
              });

              conversationComplete = true;
            } else if (response.data && response.data.Content) {
              // Single message response: response.data.Content
              console.log('Single message response:', response.data);
              let content = "I'm sorry, I couldn't generate a response.";

              if (Array.isArray(response.data.Content)) {
                const textParts = response.data.Content
                  .filter(item => item.Text)
                  .map(item => item.Text);
                content = textParts.join(' ');
                console.log('Using single message array content:', content);
              } else if (response.data.Content.Text) {
                content = response.data.Content.Text;
                console.log('Using single message Text content:', content);
              }

              // Update thinking card to show completion
              thinkingCardContent.title = "✅ Complete";
              thinkingCardContent.subtitle = "Request processed successfully";
              thinkingCardContent.isComplete = true;
              this.updateThinkingCard(thinkingCardId, thinkingCardContent);

              this.chat.Chat.push({
                content: content,
                isSent: false,
                time: new Date().toISOString(),
                HideFromUI: false,
                SkipCards: false
              });

              conversationComplete = true;
            } else {
              // Fallback response
              // Update thinking card to show completion
              thinkingCardContent.title = "✅ Complete";
              thinkingCardContent.subtitle = "Request processed successfully";
              thinkingCardContent.isComplete = true;
              this.updateThinkingCard(thinkingCardId, thinkingCardContent);

              this.chat.Chat.push({
                content: "I'm sorry, I couldn't generate a response.",
                isSent: false,
                time: new Date().toISOString(),
                HideFromUI: false,
                SkipCards: false
              });

              conversationComplete = true;
            }
          } catch (apiError) {
            console.error('API call error:', apiError);

            // Update thinking card to show error
            thinkingCardContent.title = "❌ Error";
            thinkingCardContent.subtitle = "Failed to communicate with AI service";
            thinkingCardContent.isComplete = true;
            this.updateThinkingCard(thinkingCardId, thinkingCardContent);

            // Add API error message to chat
            this.chat.Chat.push({
              content: "I'm sorry, I encountered an error while communicating with the AI service. Please try again.",
              isSent: false,
              time: new Date().toISOString(),
              HideFromUI: false,
              SkipCards: false
            });

            conversationComplete = true;
          }
        }

        // If we've exhausted all function calls, update thinking card
        if (this.functionCallCount >= this.maxFunctionCalls && !conversationComplete) {
          thinkingCardContent.title = "⚠️ Function Call Limit Reached";
          thinkingCardContent.subtitle = `Maximum of ${this.maxFunctionCalls} tool calls exceeded`;
          thinkingCardContent.isComplete = true;
          this.updateThinkingCard(thinkingCardId, thinkingCardContent);
        }
      },

      // Helper method to create thinking card content
      createThinkingCardContent(content) {
        return `<div class="thinking-card">
        <vx-card
          :title="'${content.title}'"
          :subtitle="'${content.subtitle}'"
          :collapseAction="true"
          :actionButtons="false"
          class="thinking-card-vxcard"
        >
          <div class="thinking-card-content">
            ${!content.isComplete ? `
            <div class="thinking-status mb-3">
              <div class="flex items-center">
                <div class="thinking-spinner mr-2"></div>
                <span class="text-sm text-gray-600">Processing your request...</span>
              </div>
            </div>
            ` : ''}
            <div class="function-calls-list">
              ${this.renderFunctionCallsList(content.functionCalls)}
            </div>
            ${content.isComplete ? '<div class="thinking-complete mt-3 text-sm text-green-600">✅ Request processing complete</div>' : ''}
          </div>
        </vx-card>
      </div>`;
      },

      // Helper method to update thinking card
      updateThinkingCard(cardId, content) {
        if (cardId !== null && this.chat.Chat[cardId]) {
          this.chat.Chat[cardId].content = this.createThinkingCardContent(content);
        }
      },

      // Helper method to render function calls list
      renderFunctionCallsList(functionCalls) {
        if (functionCalls.length === 0) {
          return '<div class="text-sm text-gray-500">No function calls yet...</div>';
        }

        return functionCalls.map(call => {
          let statusIcon = '⏳';
          let statusClass = 'text-gray-500';
          let statusText = 'Calling...';

          if (call.status === 'completed') {
            statusIcon = '✅';
            statusClass = 'text-green-600';
            statusText = 'Completed';
          } else if (call.status === 'error') {
            statusIcon = '❌';
            statusClass = 'text-red-600';
            statusText = 'Error';
          }

          return `
          <div class="function-call-item flex items-center justify-between py-2 border-b border-gray-100 last:border-b-0">
            <div class="flex items-center">
              <span class="mr-2">${statusIcon}</span>
              <span class="font-medium">${call.name}</span>
            </div>
            <div class="flex items-center text-sm">
              <span class="${statusClass} mr-2">${statusText}</span>
              <span class="text-gray-400">${call.timestamp}</span>
            </div>
          </div>
        `;
        }).join('');
      },
    },
    updated() {
      this.scrollToBottom();
    },
    mounted() {
      this.scrollToBottom();
    },
    components: {
      TCVCard,
      FeatherIcon,
      VxCard,
    },
  };
</script>
<style>

  .tcv-assistantGeneric {
    background: white !important;
  }

  #component-chat-log {
    max-width: 1200px;
    margin: 0 auto !important;
  }

  .chat-cart-html,
  .chat-cart-html p {
    margin-bottom: 10px !important;
    font-size: 1.2rem;
  }

    .chat-cart-html img {
      max-width: 100%;
    }

    .chat-cart-html ul,
    .chat-cart-html ol {
      padding: 10px;
      list-style: disc;
    }

    .chat-cart-html li {
      margin-bottom: 5px;
    }

    .chat-cart-html h1,
    .chat-cart-html h2,
    .chat-cart-html h3,
    .chat-cart-html h4,
    .chat-cart-html h5,
    .chat-cart-html h6 {
      margin: 20px 0px;
      font-weight: 900;
    }

  /* Function Result Card Styling */
  .function-result-card {
    margin: 10px 0;
  }

  .function-result-vxcard {
    max-width: 100% !important;
    margin: 0 !important;
  }

    .function-result-vxcard .vx-card__header {
      padding: 12px 16px;
      background: #f8f9fa;
      border-bottom: 1px solid #e9ecef;
    }

    .function-result-vxcard .vx-card__title h4 {
      font-size: 14px;
      font-weight: 600;
      margin: 0;
      color: #495057;
    }

    .function-result-vxcard .vx-card__title h6 {
      font-size: 12px;
      margin: 4px 0 0 0;
      color: #6c757d;
    }

    .function-result-vxcard .vx-card__body {
      padding: 16px;
    }

  .function-result-content {
    font-size: 13px;
  }

  .function-result-summary {
    line-height: 1.5;
    color: #495057;
  }

    .function-result-summary strong {
      color: #212529;
    }

  .function-result-details details {
    border-top: 1px solid #e9ecef;
    padding-top: 12px;
  }

  .function-result-details summary {
    outline: none;
    transition: color 0.2s;
  }

    .function-result-details summary:hover {
      color: #0056b3 !important;
    }

  .function-result-details pre {
    background: #f8f9fa !important;
    border: 1px solid #e9ecef;
    font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
    line-height: 1.4;
    max-height: 300px;
    overflow-y: auto;
  }

  /* Override VxCard default styles for chat context */
  .function-result-vxcard .vx-card {
    box-shadow: 0 2px 4px rgba(0,0,0,0.1) !important;
    border: 1px solid #e9ecef !important;
  }

  .function-result-vxcard .vx-card__collapsible-content {
    transition: all 0.3s ease;
  }

  .function-result-vxcard .vx-card__actions {
    padding: 8px 16px;
  }

  .function-result-vxcard .vx-card__action-buttons {
    display: flex;
    align-items: center;
  }

    .function-result-vxcard .vx-card__action-buttons svg {
      width: 16px;
      height: 16px;
      color: #6c757d;
      transition: color 0.2s;
    }

      .function-result-vxcard .vx-card__action-buttons svg:hover {
        color: #495057;
      }

      .function-result-vxcard .vx-card__action-buttons svg.rotate180 {
        transform: rotate(180deg);
      }

  /* Thinking Card Styling */
  .thinking-card {
    margin: 10px 0;
  }

  .thinking-card-vxcard {
    max-width: 100% !important;
    margin: 0 !important;
  }

    .thinking-card-vxcard .vx-card__header {
      padding: 12px 16px;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      border-bottom: 1px solid #e9ecef;
    }

    .thinking-card-vxcard .vx-card__title h4 {
      font-size: 14px;
      font-weight: 600;
      margin: 0;
      color: white;
    }

    .thinking-card-vxcard .vx-card__title h6 {
      font-size: 12px;
      margin: 4px 0 0 0;
      color: rgba(255, 255, 255, 0.8);
    }

    .thinking-card-vxcard .vx-card__body {
      padding: 16px;
    }

  .thinking-card-content {
    font-size: 13px;
  }

  .thinking-status {
    display: flex;
    align-items: center;
  }

  .thinking-spinner {
    width: 16px;
    height: 16px;
    border: 2px solid #e5e7eb;
    border-top: 2px solid #3b82f6;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }

  .function-calls-list {
    margin-top: 12px;
  }

  .function-call-item {
    padding: 8px 0;
    border-bottom: 1px solid #f3f4f6;
  }

    .function-call-item:last-child {
      border-bottom: none;
    }

    .function-call-item .font-medium {
      font-weight: 500;
      color: #374151;
    }

  .thinking-complete {
    padding: 8px 12px;
    background: #f0fdf4;
    border: 1px solid #bbf7d0;
    border-radius: 6px;
    color: #166534;
    font-weight: 500;
  }

  /* Override VxCard default styles for thinking card context */
  .thinking-card-vxcard .vx-card {
    box-shadow: 0 4px 6px rgba(0,0,0,0.1) !important;
    border: 1px solid #e9ecef !important;
  }

  .thinking-card-vxcard .vx-card__collapsible-content {
    transition: all 0.3s ease;
  }

  .thinking-card-vxcard .vx-card__actions {
    padding: 8px 16px;
    background: #f8f9fa;
  }

  .thinking-card-vxcard .vx-card__action-buttons {
    display: flex;
    align-items: center;
  }

    .thinking-card-vxcard .vx-card__action-buttons svg {
      width: 16px;
      height: 16px;
      color: #6c757d;
      transition: color 0.2s;
    }

      .thinking-card-vxcard .vx-card__action-buttons svg:hover {
        color: #495057;
      }

      .thinking-card-vxcard .vx-card__action-buttons svg.rotate180 {
        transform: rotate(180deg);
      }
</style>
